import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormSearchButton from '../../../../library/form/components/FormSearchButton';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import FormLink from '../../../../library/form/components/FormLink';
import FormWrapper from '../../../../library/form/components/FormWrapper'
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText'
import FormSH from '../../../../library/form/components/FormSH';
import { UiGridColTwo, UiCol, UiRow } from "../../../../library/layout/Index";

const BudgetCmnHeaderEditor = (props) => {
    const { formObject } = props;

    return (
        <>
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Target Item" />
                            </span>
                            <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink'
                                text={<SarasTrans value="Select Item" />} placeHolder="Barcode / Id..."
                                action={{ actionId: "refresh",  actionParam: {} }}
                                className='uiActionButton uiSpacerH5'
                            />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat3" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat3", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "cat3",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                            />
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiRow>
                <ul>
                    <li>
                        <div className="uiInline uiSpacerH5">
                            <FormAttachment imgHeight="50px" formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "itemImage" }} />
                        </div>
                        <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                            action={{ paramName: "itemName", actionId: "show", actionName: "itemComp" }}
                        />
                    </li>
                </ul>
            </UiRow>
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat1" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat1", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat2" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat2", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budgetDate" }} value="Budget Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "dp", paramName: "budgetDate" }} />

                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "value1" }} value="Quantity" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "value1" }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className='uiHighlightKey uiSpacerL2' />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "value2" }} value="Quantity" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "value2" }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className='uiHighlightKey uiSpacerL2' />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "currency" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "currency", acMethod: "CurrencyName", acDepCtrl: { dparam: '%dataList.valLDT' } }} />
                        </FormWrapper>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat4" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat4", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "cat5" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat5", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "cat5",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                 ></FormSH>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "location" }} value="Location" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "location", acMethod: "Location" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="Profile" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{
                                    InputType: "ac", paramName: "profile", acMethod: "ProfileName", actionId: "refresh", actionParam: { updateProfile: 1 },
                                    acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                }}
                            />
                            <FormSH formObject={formObject} rowKey="" action={{
                                actionId: "new", paramName: "profile", 
                                actionName: "proComp", actionParam: {}, containerKey: "popup"
                            }} >
                            </FormSH>
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiRow>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comment" />
                </span>
                <FormRichText formObject={formObject} rowKey="" rows="3" cols="82" className="uiFrmText"
                    action={{ paramName: "comment" }} />
            </UiRow>
        </>
    )
}

export default BudgetCmnHeaderEditor